import { ErrorMessage } from "@reactive-resume/utils";
import { isAxiosError } from "axios";

export const isIdentityLinkConflict = (error: unknown) =>
  isAxiosError(error) && error.response?.data?.code === ErrorMessage.AuthIdentityLinkConflict;
